const hamburger = document.querySelector('.hamburger');
const nav = document.querySelector('.primary-navigation');

if( hamburger ){
    hamburger.addEventListener('click', () => {
        console.log('Hamburger clicked.');
        nav.classList.toggle('active');
    })
}